import React, { useContext, useEffect, useState } from "react";
import ChatAssistant from "./ChatAssistant";
import { AppSettings } from "./../../config/app-settings.js";
import { useQuery } from "../../lib/useQuery.js";
import LoadingIndicator from "../../components/LoadingIndicator/index.jsx";
import { setAccessToken } from "../../utils/browserStorage.js";

export const ChatAssistantIFrame = () => {
  const context = useContext(AppSettings);
  const query = useQuery();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = query.get("token");
    console.log(token);
    setAccessToken(token);
    if (token) {
      setLoading(false);
    }
  }, [query]);

  useEffect(() => {
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentClass("p-0");

    return function cleanUp() {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentNone(false);
      context.setAppContentClass("");
    };

    // eslint-disable-next-line
  }, []);

  if (loading) {
    return <LoadingIndicator />;
  }

  return <ChatAssistant open={!loading} />;
};
